import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RequestWithdrawRequestDto } from "../dto/request/request-withdraw-request-dto";
import { RequestWithdrawResponseDto } from "../dto/response/request-withdraw-response-dto";
import { WithdrawalResponseDto } from "../dto/response/withdrawal-response-dto";

@Injectable({
  providedIn: "root"})
export class WithdrawalService {
  constructor(private _httpClient: HttpClient) {}

  requestWithdrawal(
    request: RequestWithdrawRequestDto,
    turnstileToken: string
  ): Observable<RequestWithdrawResponseDto> {
    return this._httpClient.post<RequestWithdrawResponseDto>(
      `${environment.backend}/withdrawal-requests`,
      request,
      {
        headers: {
          "X-Turnstile-Token": turnstileToken}}
    );
  }

  requestExpressWithdrawal(
    request: RequestWithdrawRequestDto,
    turnstileToken: string
  ): Observable<RequestWithdrawResponseDto> {
    return this._httpClient.post<RequestWithdrawResponseDto>(
      `${environment.backend}/withdrawal-requests/express`,
      request,
      {
        headers: {
          "X-Turnstile-Token": turnstileToken}}
    );
  }

  getWithdrawal(
    walletId: string,
    page: number,
    pageSize: number
  ): Observable<WithdrawalResponseDto> {
    return this._httpClient.get<WithdrawalResponseDto>(
      `${environment.backend}/withdrawal-requests?walletId=${walletId}&page=${page}&pageSize=${pageSize}`
    );
  }
}
